export default __webpack_public_path__ + "static/media/kid-4.45c98e5c.JPG";